import React from 'react'
import {TimeUtils} from '@colonist/utils'

function turnSecondsInToTimerFormat(time: number): string {
    const hours = Math.floor(time / TimeUtils.MINUTES_IN_HOUR / TimeUtils.SECONDS_IN_MINUTE)
    const minutes = Math.floor(time % (TimeUtils.SECONDS_IN_MINUTE * TimeUtils.MINUTES_IN_HOUR) / TimeUtils.SECONDS_IN_MINUTE)
    const seconds = Math.floor(time % TimeUtils.SECONDS_IN_MINUTE)

    let text = ''
    if(hours > 0) {
        text += hours + ':'
    }

    text += String(minutes).padStart(2, '0')
    text += ':'
    text += String(seconds).padStart(2, '0')
    return text
}

export interface TimerProps {
    timeLeftInSeconds: number | undefined
    className?: string
}

export const Timer = ({
    timeLeftInSeconds,
    className,
}: TimerProps) => {
    const formattedTime = turnSecondsInToTimerFormat(timeLeftInSeconds ?? 0)

    return <div className={className}>
        {formattedTime}
    </div>
}
